import React from "react";
import PropTypes from "prop-types";

import Page from "../../components/Page";
import CenteredPageContentContainer from "../../components/CenteredPageContentContainer";
import PaperContainer from "../../components/PaperContainer";
import DuplicateShiftForm from "../../components/forms/DuplicateShiftForm";
import ShiftForm from "../../components/forms/ShiftForm";
import { FormMode } from "../../types/enums";

const DuplicateShiftPage = (props) => (
  <Page enableGoBack title="Dienst dupliceren">
    <CenteredPageContentContainer>
      <PaperContainer title="Dienstgegevens" isAccordion={true}>
        <ShiftForm mode={FormMode.VIEW} shiftId={props.match.params.shift_id} />
      </PaperContainer>
    </CenteredPageContentContainer>
    <CenteredPageContentContainer>
      <PaperContainer title="Dupliceer dienst">
        <DuplicateShiftForm shiftId={props.match.params.shift_id} />
      </PaperContainer>
    </CenteredPageContentContainer>
  </Page>
);

DuplicateShiftPage.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      shift_id: PropTypes.string.isRequired,
    }),
  }),
};

export default DuplicateShiftPage;



// WEBPACK FOOTER //
// ./src/pages/Shift/DuplicateShiftPage.js